// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { PlasmicMission } from "./plasmic/o_21_p_partner_2_0_0_prod/PlasmicMission";
import { Helmet } from "react-helmet-async";

function Mission_(props, ref) {
  return (
      <>
        <Helmet>
          <title>o21p mission.</title>
        </Helmet>
  
        <PlasmicMission root={{ ref }} {...props} />
      </>
    );
}

const Mission = React.forwardRef(Mission_);

export default Mission;
